@if ($authorized()) {
  @let action = $action();

  <a
    role="button"
    type="button"
    [class]="$buttonClasses()"
    [class.disabled]="$disabled()"
    [routerLink]="action.url"
    [queryParams]="$queryParams()"
    [title]="action.description"
    (click)="onClick($event)"
    (keydown)="onClick($event)">
    <kendo-stacklayout class="title-container" orientation="horizontal" [gap]="15" [align]="{ horizontal: 'start' }">
      <kendo-svg-icon class="action-icon" size="xlarge" [icon]="$actionIcon()" />
      <span>{{ action.actionName }}</span>
    </kendo-stacklayout>
  </a>
}
